import ModalComponent from '../../../../shared/components/Modals/ModalComponent'
import ModalBody from '../../../../shared/components/Modals/ModalBody'
import { PlansModalFace } from '../../../../shared/utils/interfaces/planInterface'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsLoadingCurrentPlan, selectPlansModalOpen, setPlansModalOpen } from '../../slice/settingsSlice'
import { selectCurrentUser } from '../../../authentication/slice/authSlice'
import PlansList from './PlansList'

export default function PlansModal({ title, subtitle }: PlansModalFace) {
    const dispatch = useDispatch();
    const modalOpen = useSelector(selectPlansModalOpen);
    const currenPlan = useSelector(selectCurrentUser)?.plan;
    const isLoadingCurrentPlan = useSelector(selectIsLoadingCurrentPlan)

    const handleCloseModal = () => {
        dispatch(setPlansModalOpen(false));
    }

    return (
        <ModalComponent
            className='my-6 !w-[75%]'
            visibleModal={modalOpen}
            handleCloseModal={isLoadingCurrentPlan ? () => { } : handleCloseModal}
            content={
                <ModalBody
                    title={title ?? "Upgrade your plan"}
                    subtitle={subtitle ?? `You are currently enjoying peopleCQ ${currenPlan?.name} plan`}
                >
                    <PlansList />
                </ModalBody>
            }
        />
    )
}
